<template>
  <div>
    <p class="py-4">
      {{ $t("message.loginComponent.firstToKnow") }}
      <a @click="activeForgotPasswordModal">{{ $t("message.resetPassComponent.recoverPassword") }}</a>
    </p>
    <p class="pb-6">
      {{ $t("message.HeaderComponent.omitNotification") }}
    </p>
    <div class="overflow-y-auto height-company">
      <div v-for="(company, index) in linkUserDataFormArray" :key="index"
        class="w-full flex mx-auto border rounded border-custom-gray box-custom-height h-24 mb-2 justify-between align-center">
        <div>
          <div class="w-32 h-20 flex flex-wrap justify-center items-center mx-4 mx-auto">
            <div class="w-full logo-company-change-box flex items-center justify-center">
              <logo-company :user-id="parseInt(company.companyId)" noSave />
            </div>
            <div class="hidden w-full flex justify-center items-center">
              <span class="w-full font-bold text-zt-dark-500 text-zt-md">{{ company.companyName }}</span>
            </div>
          </div>
        </div>
        <div class="text-right mr-4 w-2/6 flex justify-end items-center">
          <span class="w-full font-bold text-zt-dark-500">{{ company.companyName }}</span>
        </div>
      </div>
    </div>
    <forgot-password-help-modal :visible="isForgotPasswordHelpModal" @close="handleCloseModal" />
  </div>
</template>

<script>
import ForgotPasswordHelpModal from "../components/ForgotPasswordHelpModal.vue";
import LogoCompany from "@/components/commons/LogoCompany";
import { mapState } from 'vuex';
import { useWindowResize } from '@sichern/ui-elements'

export default {
  components: {
    LogoCompany,
    ForgotPasswordHelpModal,
  },
  props: {
    linkUserDataFormArray: {
      type: Array,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      windowResize: useWindowResize(this),
      isForgotPasswordHelpModal: false,
    };
  },
  computed: {
    ...mapState(['linkUserMergeCandidates']),
    isMobile() {
      return this.windowResize.width < 1024;
    },
    logoIds() {
      return this.linkUserDataFormArray.map(company => parseInt(company.companyId));
    },
  },
  methods: {
    linkUserAccount() {
      if (this.step === this.linkUserDataFormArray.length) {
        this.$router.push({ path: "/" });
      }
    },
    activeForgotPasswordModal() {
      console.log('open modal');
      this.isForgotPasswordHelpModal = true;
    },
    handleCloseModal() {
      this.isForgotPasswordHelpModal = false;
    }
  },
};
</script>

<style lang="scss" scoped>
/* Agrega tus estilos aquí */
</style>
